// Гейт админ-дашборда. Пароль проверяется на сервере (/api/dashboard/gate/),
// в бандле фронтенда его больше нет.
import React, { useState } from 'react';

export default function PasswordGate({ onSuccess }) {
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState('');
  const [checking, setChecking] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (checking) return;
    setErr('');
    setChecking(true);
    try {
      const token = localStorage.getItem('token');
      const resp = await fetch('/api/dashboard/gate/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password: pwd }),
      });
      if (resp.ok) {
        onSuccess();
      } else {
        setErr('Wrong password');
      }
    } catch {
      setErr('Network error. Please try again.');
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <form onSubmit={submit} className="bg-white p-6 shadow rounded w-full max-w-xs">
        <h2 className="text-lg font-semibold mb-3">Enter dashboard password</h2>
        <input
          type="password"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          placeholder="Password"
          className="border w-full p-2 mb-3"
        />
        {err && <div className="text-red-600 text-sm mb-2">{err}</div>}
        <button
          type="submit"
          disabled={checking}
          className="w-full bg-[#0F2C5E] text-white py-2 disabled:opacity-60"
        >
          {checking ? 'Checking…' : 'Continue'}
        </button>
      </form>
    </div>
  );
}
